import { PlusIcon } from "@/icons/solid";
import { Actions as EMPLOYEE_ACTIONS } from "@/redux/actions/employeeActions";
import { format } from "date-fns";
import { groupBy } from "lodash";
import { connect } from "react-redux";
import Occupation from "./Occupation";
import { mapOccupationsForDropdown } from "@/helpers/Remappers";
const today = format(new Date(), "yyyy-MM-dd");

function Occupations({ hasMultiRole, occupation, newOccupationModal, occupationList, forNewEmployee }) {
	if (forNewEmployee || !hasMultiRole || (hasMultiRole && occupation)) return null;
	return (
		<div className="col-xs-12 form-section">
			<div className="col-xs-2 section-header">
				<h1>Occupations</h1>
			</div>
			<div className="col-xs-10 p-0">
				<button
					className="btn btn-success pull-right"
					type="button"
					onClick={() => {
						newOccupationModal();
					}}
				>
					<PlusIcon className="h-8 w-8 align-middle" />
					Add Occupation
				</button>
			</div>
			<div className="clearfix" />
			<ActiveOccupations occupationList={occupationList} />
			<PreviousOccupations occupationList={occupationList} />
			<div className="clearfix" />
		</div>
	);
}

function ActiveOccupations({ disabled, occupationList = [] }) {
	const occupations = occupationList.filter((o) => !o.end || o.end >= today);

	if (!occupations.length) return null;

	return (
		<div className="mb-8">
			<div className="col-xs-2">
				<h3 className="uppercase text-2xl">Active</h3>
			</div>
			<div className="col-xs-12">
				{occupations.map((o) => (
					<Occupation
						key={o.id}
						occupation={o}
						disabled={disabled}
					/>
				))}
			</div>
			<div className="clearfix" />
		</div>
	);
}

function PreviousOccupations({ occupationList, disabled }) {
	const occupations = occupationList.filter((o) => o.end < today);

	if (!occupations.length) return null;

	return (
		<div className="mb-8">
			<div className="col-xs-2">
				<h3 className="uppercase text-2xl">Previous</h3>
			</div>
			<div className="col-xs-12">
				{occupations.map((o) => (
					<Occupation
						key={o.id}
						occupation={o}
						disabled={disabled}
					/>
				))}
			</div>
			<div className="clearfix" />
		</div>
	);
}

const mapStateToProps = (state) => {
	const occupations = state.employee?.agreementInfo?.occupations;

	const roles = groupBy(state.employee?.roles || [], "occupation");
	const departments = groupBy(state.employee?.departments || [], "occupation");
	const pensions = groupBy(state.employee?.pensionPlans || [], "occupation");
	const salaries = groupBy(state.employee?.salaries || [], "occupation");

	const occupationList = mapOccupationsForDropdown(
		occupations?.map((o) => ({
			occupation: o,
			roles: roles[o] || [],
			departments: departments[o] || [],
			pensions: pensions[o] || [],
			salaries: salaries[o] || [],
		})),
		state.company?.settings?.departments,
	);

	return {
		occupationList,
		occupations: state.employee?.employeeDetails?.occupations,
		hasMultiRole: state.company?.settings?.hasMultiRole,
	};
};

const mapDispatchToProps = (dispatch) => ({
	newOccupationModal: () => dispatch(EMPLOYEE_ACTIONS.newOccupationModal(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Occupations);
